// add twitter bootstrap classes and color based on how many times tag is used
function addTwitterBSClass(thisObj) {
    var title = jQuery(thisObj).attr('title');
    if (title) {
        var titles = title.split(' ');
        if (titles[0]) {
            jQuery(thisObj).addClass('label label-default');
        }
    }
    else
        jQuery(thisObj).addClass('label');
    return true;
}



/**
 * A seconda del breakpoint faccio aprire il dropdown della ricerca in alto o in basso
 * @returns {undefined}
 */
function search_dropdown_position() {
    windowWidth = jQuery(window).width();
    
    grid_float_breakpoint = 820;
    searchDropDown = jQuery('#service-nav-searchform .input-group-btn');
    
    if (windowWidth < grid_float_breakpoint) {
        searchDropDown.addClass('dropup');
    } else {
        searchDropDown.removeClass('dropup');
    }
}

// as the page loads, call these scripts
jQuery(document).ready(function ($) {
    
    windowWidth = $(window).width(); 
    grid_float_breakpoint = 820;

    // modify tag cloud links to match up with twitter bootstrap
    $("#tag-cloud a").each(function () {
        addTwitterBSClass(this);
        return true;
    });

    $("p.tags a").each(function () {
        addTwitterBSClass(this);
        return true;
    });

    $("ol.commentlist a.comment-reply-link").each(function () {
        $(this).addClass('btn btn-success btn-mini');
        return true;
    });

    $('#cancel-comment-reply-link').each(function () {
        $(this).addClass('btn btn-danger btn-mini');
        return true;
    });

    // $('article.post').hover(function(){
    // 	$('a.edit-post').show();
    // },function(){
    // 	$('a.edit-post').hide();
    // });

    // Prevent submission of empty form
    $('[placeholder]').parents('form').submit(function () {
        $(this).find('[placeholder]').each(function () {
            var input = $(this);
            if (input.val() == input.attr('placeholder')) {
                input.val('');
            }
        })
    });

    $('.alert-message').alert();

    $('.dropdown-toggle').dropdown();

    $('#mainHeader').infinitewalker();


    $('.slide-highlights').slick({ 
        infinite: true,
        centerMode: true,
        dots: false,
        slidesToShow: 3,
        slidesToScroll: 1,
        prevArrow: '#prev',
        nextArrow: '#next',
        autoplay: false,
        autoplaySpeed: 4000,
        variableWidth: true,
        responsive: [
            {
                breakpoint: 980,
                settings: {
                    centerMode: false,
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    });

    $('#section-enti').slick({
        arrows: false,
        infinite: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 4000,
        responsive: [
            {
                breakpoint: 1300,
                settings: {
                    slidesToShow: 5
                }
            },
            {
                breakpoint: 980,
                settings: {
                    slidesToShow: 4
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1
                }
            }
        ]
    });


    
    /**
     * Al click sul pulsante scroll della pagina fino alla mappa
     */
    $('#btn-go-to-map').click(function () {
        $("html, body").animate({
            scrollTop: $('#section-map-enti').offset().top - 120
        }, 1000);
    });

});

jQuery( window ).load(function() {
    jQuery('.slide-highlights-container , #section-enti').removeClass('hidden');
});